var cilSim = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M384,40H230.627A31.791,31.791,0,0,0,208,49.373L97.373,160A31.791,31.791,0,0,0,88,182.627V448a32.036,32.036,0,0,0,32,32H384a32.036,32.036,0,0,0,32-32V72A32.036,32.036,0,0,0,384,40Zm0,408H120V182.627L230.627,72H384Z' class='ci-primary'/><path fill='var(--ci-primary-color, currentColor)' d='M208,416H352V216H208Zm32-168h80V384H240Z' class='ci-primary'/>"];

export { cilSim };

